// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"181":"components-count-up","712":"components-media-slider","890":"components-scroll-to"}[chunkId] || chunkId) + ".js";
};